const formatDate = function (date) {
  if (typeof date === "object") {
    let month = date.getMonth()+1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    return day + "/" + month + "/" + date.getFullYear();
  } else {
    let dateParts = date.split("/");
    return dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
  }
}

// const DDMMYYYY_toDayObject = function(date) {
//   const dateMomentObject = moment(dateString, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
//   var dateObject = dateMomentObject.toDate();
// }

export {
  formatDate
}
